if (process.env.NODE_ENV === 'production') {
  module.exports = require('./dist/entity-sauce.production.min.js')
} else {
  module.exports = require('./dist/entity-sauce.development.js')
}
